enum UWRequirementType {
  Integration = 1,
  Manual = 2,
}

export default UWRequirementType;